/* eslint-disable react/require-default-props */
import React from 'react';
import { FilterBar } from '@ui/organisms/FilterBar';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import useComponentFilters from '../hooks/useComponentFilters';
const namespace = 'components.tab';
export default function ComponentsFilterPanel({ filters, onFiltersChange, componentTypes, onResetCache }) {
    const handleResetFilters = () => {
        onFiltersChange({
            search: '',
            typeIds: [],
            activeState: 'active'
        });
    };
    const filtersList = useComponentFilters({
        filters,
        onFiltersChange,
        componentTypes
    });
    return (React.createElement(FilterBar, { filters: filtersList, showSearch: true, searchValue: filters.search, onSearchChange: (value) => onFiltersChange(Object.assign(Object.assign({}, filters), { search: value })), searchPlaceholder: translate('search_placeholder', { namespace }), onResetFilters: handleResetFilters }, process.env.RAILS_ENV !== 'production' && onResetCache && (React.createElement(Button, { type: "button", variant: "highlighted", onClick: onResetCache }, translate('reset_cache', { namespace })))));
}
